if (!window.Maximize.loadedScript.includes("product-picker.js")) {
  window.Maximize.loadedScript.push("product-picker.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xProductPicker", (priceFilterStyle, sectionId) => ({
        collectionUrl: "",
        templateFilter: "",
        filterOption: [],
        listRenderedFilter: [],
        isLoading: false,
        showResultText: false,
        numberFilter: 3,

        init() {
          const templateEl = this.$root.querySelector(".template-filter");
          this.templateFilter = templateEl ? templateEl.innerHTML : "";
        },

        handleCollectionSelectChange(event) {
          const selectElement = event.target;
          const filtersData = JSON.parse(selectElement.dataset.filters || "[]");

          this.collectionUrl = event?.detail?.value || "";
          this.filterOption = filtersData;
          this.showResultText = false;
          this.listRenderedFilter = [];

          this.resetAllFilterWrappers();
          this.fetchFilter(false);
        },

        fetchFilter(isChangeResult = false, url = "", retryCount = 0) {
          if (!this.collectionUrl && !url) return;

          let urlParam = `${this.collectionUrl}?section_id=product-picker-filter`;
          if (url) {
            urlParam = url;
          }

          this.isLoading = true;

          fetch(urlParam)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, "text/html");

              if (isChangeResult) {
                this.renderResultCount(html);

                let shouldRefetch = false;

                for (let i = 0; i < this.numberFilter; i++) {
                  const currentFilter = this.filterOption[i];
                  if (!currentFilter || !currentFilter.filter) continue;

                  const invalidSelectionRemoved = this.renderOptionListFilter(
                    html,
                    currentFilter.filter,
                    currentFilter.title,
                    currentFilter.dropdownFormat,
                    i
                  );

                  if (invalidSelectionRemoved) {
                    shouldRefetch = true;
                  }
                }

                if (shouldRefetch && retryCount < 2) {
                  const formParams = this.getFormParams(this.$refs[`form_${sectionId}`]);
                  const nextUrl = `${this.collectionUrl}?${formParams}&section_id=product-picker-filter`;
                  this.fetchFilter(true, nextUrl, retryCount + 1);
                }
              } else {
                for (let i = 0; i < this.numberFilter; i++) {
                  const currentFilter = this.filterOption[i];
                  if (!currentFilter) continue;

                  this.renderListFilter(
                    html,
                    currentFilter.filter,
                    currentFilter.title,
                    currentFilter.dropdownFormat,
                    i
                  );
                }

                this.renderResultCount(html);
              }
            })
            .catch((error) => {
              console.error("Product picker fetch error:", error);
            })
            .finally(() => {
              this.isLoading = false;
            });
        },

        renderListFilter(html, filterName, filterTitle, dropdownFormat, index) {
          const oldElement = this.$root.querySelector(`.filter-${index + 1}__wrapper`);
          if (!oldElement) return;

          if (!filterName) {
            oldElement.innerHTML = this.templateFilter;
            this.setDefaultButtonLabel(oldElement, filterTitle || this.getDefaultSelectText());
            return;
          }

          if (this.listRenderedFilter.includes(filterName)) {
            oldElement.innerHTML = this.templateFilter;
            this.setDefaultButtonLabel(oldElement, filterTitle || filterName || this.getDefaultSelectText());
            return;
          }

          const listResult = this.getListResult(html, filterName);

          if (listResult) {
            this.prepareFilterMarkup(listResult, filterTitle, dropdownFormat);

            if (listResult.dataset.type === "price") {
              oldElement.innerHTML =
                listResult.querySelector(`[data-price-filter-type="${priceFilterStyle}"]`)?.innerHTML ||
                this.templateFilter;
            } else {
              oldElement.innerHTML = listResult.innerHTML;
            }

            this.listRenderedFilter.push(filterName);
            this.setEmptyFilterLabel(oldElement, filterTitle || filterName);
          } else {
            oldElement.innerHTML = this.templateFilter;
            this.setDefaultButtonLabel(oldElement, filterTitle || filterName || this.getDefaultSelectText());
          }
        },

        getFormParams(formElement) {
          const formData = new FormData(formElement);

          for (const pair of Array.from(formData.entries())) {
            if (!pair[1]) {
              formData.delete(pair[0]);
            }
          }

          return new URLSearchParams(formData).toString();
        },

        handleClick(event) {
          event.preventDefault();

          if (!this.collectionUrl) {
            return;
          }

          const formParams = this.getFormParams(this.$refs[`form_${sectionId}`]);

          if (formParams) {
            window.location.href = `${this.collectionUrl}?${formParams}`;
          } else {
            window.location.href = this.collectionUrl;
          }
        },

        handleOptionChange() {
          if (!this.collectionUrl) {
            return;
          }

          const formParams = this.getFormParams(this.$refs[`form_${sectionId}`]);
          const nextUrl = formParams
            ? `${this.collectionUrl}?${formParams}&section_id=product-picker-filter`
            : `${this.collectionUrl}?section_id=product-picker-filter`;

          this.fetchFilter(true, nextUrl);
        },

        renderResultCount(html) {
          const totalResult = html.querySelector(".total-result");
          if (totalResult) {
            this.showResultText = totalResult.textContent;
          }
        },

        renderOptionListFilter(html, filterName, filterTitle, dropdownFormat, index) {
          if (!filterName) return false;

          const listResult = this.getListResult(html, filterName);
          const oldElement = this.$root.querySelector(`.filter-${index + 1}__wrapper`);
          if (!oldElement) return false;

          const previousSelectedValue = this.getSelectedValueFromWrapper(oldElement);
          let invalidSelectionRemoved = false;

          if (listResult) {
            this.prepareFilterMarkup(listResult, filterTitle, dropdownFormat);

            if (listResult.dataset.type === "price") {
              oldElement.innerHTML =
                listResult.querySelector(`[data-price-filter-type="${priceFilterStyle}"]`)?.innerHTML ||
                this.templateFilter;
            } else {
              oldElement.innerHTML = listResult.innerHTML;
            }

            const isStillValid = this.isValueAvailableInFilter(oldElement, previousSelectedValue);

            if (previousSelectedValue && isStillValid) {
              this.restoreSelectedValue(oldElement, previousSelectedValue);
            } else if (previousSelectedValue) {
              invalidSelectionRemoved = true;
              this.clearCurrentAndNextFilters(index, html);
            }

            this.setEmptyFilterLabel(oldElement, filterTitle || filterName);
          } else {
            oldElement.innerHTML = this.templateFilter;
            this.setDefaultButtonLabel(oldElement, filterTitle || filterName || this.getDefaultSelectText());

            if (previousSelectedValue) {
              invalidSelectionRemoved = true;
              this.clearCurrentAndNextFilters(index, html);
            }
          }

          return invalidSelectionRemoved;
        },

        clearCurrentAndNextFilters(startIndex, html) {
          for (let i = startIndex; i < this.numberFilter; i++) {
            const currentFilter = this.filterOption[i];
            const wrapper = this.$root.querySelector(`.filter-${i + 1}__wrapper`);
            if (!wrapper) continue;

            if (!currentFilter || !currentFilter.filter) {
              wrapper.innerHTML = this.templateFilter;
              this.setDefaultButtonLabel(wrapper, this.getDefaultSelectText());
              continue;
            }

            if (i === startIndex) {
              const freshFilter = this.getListResult(html, currentFilter.filter);

              if (freshFilter) {
                this.prepareFilterMarkup(
                  freshFilter,
                  currentFilter.title,
                  currentFilter.dropdownFormat
                );

                if (freshFilter.dataset.type === "price") {
                  wrapper.innerHTML =
                    freshFilter.querySelector(`[data-price-filter-type="${priceFilterStyle}"]`)?.innerHTML ||
                    this.templateFilter;
                } else {
                  wrapper.innerHTML = freshFilter.innerHTML;
                }

                this.setEmptyFilterLabel(wrapper, currentFilter.title || currentFilter.filter);
              } else {
                wrapper.innerHTML = this.templateFilter;
                this.setDefaultButtonLabel(
                  wrapper,
                  currentFilter.title || currentFilter.filter || this.getDefaultSelectText()
                );
              }
            } else {
              wrapper.innerHTML = this.templateFilter;
              this.setDefaultButtonLabel(
                wrapper,
                currentFilter.title || currentFilter.filter || this.getDefaultSelectText()
              );
            }
          }
        },

        restoreSelectedValue(wrapper, value) {
          if (!wrapper || !value) return;

          const hiddenInput = wrapper.querySelector(".select-option-selected");
          if (hiddenInput) {
            hiddenInput.value = value;
          }

          const selectedOption = wrapper.querySelector(
            `.select-option[data-value="${CSS.escape(value)}"], .select-option[data-select-value="${CSS.escape(value)}"]`
          );

          const labelEl = wrapper.querySelector(".select-button__label");
          if (labelEl && selectedOption) {
            labelEl.textContent = selectedOption.dataset.selectValue || selectedOption.textContent.trim();
          }
        },

        isValueAvailableInFilter(wrapper, value) {
          if (!wrapper || !value) return false;

          const options = wrapper.querySelectorAll(".select-option");
          for (const option of options) {
            const optionValue = option.dataset.value || option.dataset.selectValue || option.textContent.trim();
            if ((optionValue || "").trim() === value.trim()) {
              return true;
            }
          }

          return false;
        },

        getSelectedValueFromWrapper(wrapper) {
          if (!wrapper) return "";
          const input = wrapper.querySelector(".select-option-selected");
          return input ? (input.value || "").trim() : "";
        },

        prepareFilterMarkup(listResult, filterTitle, dropdownFormat) {
          const selectElementLabels = listResult.querySelectorAll(".parent-text-label");
          if (selectElementLabels.length && filterTitle) {
            selectElementLabels.forEach((ele) => {
              ele.textContent = filterTitle;
            });
          }

          const swatchLabels = listResult.querySelectorAll(".swatch-option__label");
          swatchLabels.forEach((element) => {
            element.dataset.typeDisplay = dropdownFormat;
          });
        },

        setEmptyFilterLabel(wrapper, fallbackText) {
          if (!wrapper) return;

          const input = wrapper.querySelector(".select-option-selected");
          const labelEl = wrapper.querySelector(".select-button__label");

          if (!input || !labelEl) return;

          if (!input.value || !input.value.trim()) {
            labelEl.textContent = fallbackText || this.getDefaultSelectText();
          }
        },

        setDefaultButtonLabel(wrapper, text) {
          if (!wrapper) return;

          const buttonLabelEl = wrapper.querySelector(".select-button__label");
          if (buttonLabelEl) {
            buttonLabelEl.textContent = text || this.getDefaultSelectText();
          }
        },

        resetAllFilterWrappers() {
          for (let i = 0; i < this.numberFilter; i++) {
            const wrapper = this.$root.querySelector(`.filter-${i + 1}__wrapper`);
            if (!wrapper) continue;

            wrapper.innerHTML = this.templateFilter;

            const currentFilter = this.filterOption[i];
            this.setDefaultButtonLabel(
              wrapper,
              currentFilter?.title || currentFilter?.filter || this.getDefaultSelectText()
            );
          }
        },

        getDefaultSelectText() {
          return window?.themeStrings?.productPickerSelect || "Select";
        },

        getListResult(html, filterName) {
          let listResult = null;
          const listFilterName = (filterName || "").trim().split(";");

          for (let i = 0; i < listFilterName.length; i++) {
            const currentName = listFilterName[i]?.trim();
            if (!currentName) continue;

            const found = html.querySelector(`div[data-label="${CSS.escape(currentName)}"]`);
            if (found) {
              listResult = found;
              break;
            }
          }

          return listResult;
        },
      }));
    });
  });
}